export default __webpack_public_path__ + "static/media/117_mobile.8cfafafb.jpg";